import React from 'react';
import TopLanding from '../../shared/components/TopLanding';

function About() {
    return (
        <div>
            <TopLanding />
        </div>
    )
}

export default About;
